import ResourceTLModalView from "./resourceTLModal.html";


angular.module("languages")


    .controller('LanguagesListCtrl', ['LoginService', '$q', '$scope', '$translate', 'Restangular', '$rootScope', '$filter', 'uiGridTreeViewConstants', 'gridService', 'treeService', 'modalService', '$uibModal', function (LoginService, $q, $scope, $translate, Restangular, $rootScope, $filter, uiGridTreeViewConstants, gridService, treeService, modalService, $uibModal) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("RESOURCE_WRITE");

        $scope.languages = [];
        $rootScope.title = $filter('translate')('languages.title');

        $scope.search = {
            textSearch: null,
            code: null
        }
  
        $rootScope.breadcrumb = [
            { title: $filter('translate')('languages.title') }
        ];

        $scope.language_code_tree = $translate.use();
        $scope.language_id_tree = 1;

        $scope.selectedLanguage = {};
        Restangular.all('Languages').getList().then(function (languages) {
            $scope.languages = languages;
            angular.forEach(languages, function (language) {
                if (language.code == $translate.use()) {
                    $scope.selectedLanguage.selected = language;
                    $scope.language_id_tree = language.id;
                }
            });
        });
        
        $scope.$watch('selectedLanguage.selected', function (newValue, oldValue) {
            if (angular.isDefined(oldValue) && newValue.code != oldValue.code) {
                $scope.language_code_tree = newValue.code;
                $scope.language_id_tree = newValue.id;
                $scope.gridOptions.gridApi.core.raise.itemChanged($scope);
            }
        });


        //mostramos el grid.
        $scope.gridOptions = {
            pdfTitle: "Traducciones",
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            showTreeExpandNoChildren: true,
            enableCellEditOnFocus: $scope.allowWrite,
            paginationPageSizes: [200, 250, 300],
            paginationPageSize: 200,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;

                //Edición y creación en linea
                if ($scope.allowWrite) {
                    this.gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValue, oldValue) {

                        if (angular.isDefined(newValue) && newValue != "") {
                            if (!angular.isDefined(rowEntity.FK_resources_tl_resources_id)) {
                                $scope.translationData = {
                                    resource_id: rowEntity.id,
                                    language_id: rowEntity.language_id,
                                    value: newValue
                                }
                                Restangular.all('ResourcesTl').post($scope.translationData).then(function (result) {
                                    if (angular.isDefined(result.id)) {
                                        rowEntity.FK_resources_tl_resources_id = result.id;
                                        toastr.success($filter('translate')('languages.create_success'));
                                    } else {
                                        toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + result.message);
                                    }
                                }, function (response) {
                                    toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + response.message);
                                });
                            } else {
                                Restangular.one('ResourcesTl', rowEntity.FK_resources_tl_resources_id).get().then(function (results) {
                                    $scope.resources_tl = results;
                                    $scope.resources_tl.value = newValue;
                                    $scope.resources_tl.put().then(function (result) {
                                        if (angular.isDefined(result.id)) {
                                            toastr.success($filter('translate')('languages.edit_success'));
                                        } else {
                                            toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + result.message);
                                        }
                                    });
                                }, function (response) {
                                    toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + response.message);
                                });
                            }
                        }

                        $scope.$apply();
                    });
                }
            },
            columnDefs: [
              { name: 'module', displayName: $filter('translate')('languages.module'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, enableCellEdit: false, width: '15%' },
              { name: 'code', displayName: $filter('translate')('languages.code'), enableFiltering: true, enableSorting: false, enableHiding: false, enableColumnMenu: false, enableCellEdit: false, width: '15%' },
              { name: 'value', displayName: $filter('translate')('languages.value'), enableFiltering: false, enableSorting: false, enableHiding: false, enableColumnMenu: false, enableCellEdit: true, width: '50%' },
              {
                  name: ' ', exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: "Editar", action: 'ng-show="row.entity.code!=\'\'" ng-click="grid.appScope.EditDialog(row.entity.id, row.entity.FK_resources_tl_resources_id, row.entity.language_id, row.entity.code, row.entity.value)"  ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                var deferred = $q.defer();
                options.lang = $scope.language_code_tree;
                options.textSearch = $scope.search.textSearch;
                options.code = $scope.search.code;
                Restangular.all('Resources').getList(options).then(function (results) {                    
                    let array_resources = [];
                    var treeLevel = 0;
                    var nombreModulo = "";

                    var data = treeService.languageTree(results, $scope.language_id_tree);
                    data.totalRows = results.totalRows;
                    deferred.resolve(data);

                }, function (response) {
                   alert(response.message);
                });

                return deferred.promise;
            }

        };

        $scope.searchText = function () {
            $scope.gridOptions.loadData(false);
        }

        $scope.clearFilters = function () {
            $scope.search = {
                textSearch: null
            };
            $scope.gridOptions.loadData(false);
        }

        $scope.EditDialog = function (id, resources_tl_id, language_id, code, valueToChange) {  
            $scope.translate = {
                resource_id: id,
                id: resources_tl_id,
                language_id: language_id,
                code: code,
                value: valueToChange
            }
            let $modalInstance = $uibModal.open({
                animation: true,
                template: ResourceTLModalView,
                controller: "ResourceModalCtrl",
                resolve: {
                    resources_tl: function () {
                        return $scope.translate;
                    }
                }
            });

            $modalInstance.result.then(function (resultModal) {
                if (angular.isDefined(resultModal.value) && resultModal.value != "") {

                    if (!angular.isDefined(resultModal.id) || resultModal.id == 0) {
                        //Creamos
                        Restangular.all('ResourcesTl').post(resultModal).then(function (result) {
                            if (angular.isDefined(result.id) && result.id != 0) {
                                toastr.success($filter('translate')('languages.create_success'));
                                $scope.gridOptions.gridApi.core.raise.itemChanged($scope);
                            } else {
                                toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + result.message);
                            }
                        }, function (response) {
                            toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + response);
                        });
                    } else {
                        //Modificamos
                        Restangular.one('ResourcesTl', resultModal.id).get().then(function (results) {
                            $scope.resources_tl = results;
                            $scope.resources_tl.value = resultModal.value;
                            $scope.resources_tl.put().then(function (result) {
                                if (angular.isDefined(result.id) && result.id != 0) {
                                    toastr.success($filter('translate')('languages.edit_success'));
                                    $scope.gridOptions.gridApi.core.raise.itemChanged($scope);
                                } else {
                                    toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + result.message);
                                }
                            }, function (response) {
                                toastr.error("Ha ocurrido un error, no se ha guardado con éxito." + response.message);
                            });
                        });
                    }
                }
                

            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });

        }; //EditDialog
        
    }])



    .controller("ResourceModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', 'resources_tl', function ($scope, $uibModalInstance, Restangular, modalService, resources_tl) {
    
        $scope.resourceTlModal = angular.isDefined(resources_tl) ? resources_tl : {};

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.saveTranslation = function () {
            //Devolvemos el control al principal
            $uibModalInstance.close($scope.resourceTlModal);

        };//saveTranslation


    }])





;